/* References: 
- https://github.com/gnbaron/use-lodash-debounce
- https://dmitripavlutin.com/react-throttle-debounce/
*/import debounce from"lodash.debounce";import{useCallback}from"react";export function useDebouncedFunction(a,b,c){return useCallback(debounce(a,b,c),[a,b,c])}